import Auth0 from 'auth0-js'
import { Tenant } from '@/types'

/**
  Marks the user as logged out with AuthX
* */
export const logoutFromAuth0 = (tenant: Tenant, redirectUri: string) => {

  if (!tenant) {
    throw new Error('TenantRequired')
  }

  if (!redirectUri) {
    throw new Error('RedirectURIRequired')
  }

  const webAuth = new Auth0.WebAuth({
    domain: tenant.loginDomain,
    clientID: tenant.loginClientId,
  })

  // blanking out clientID as our logout returnTo whitelist is at tenant level instead of client level
  webAuth.logout({
    returnTo: redirectUri,
    clientID: '',
  })

}
